/* @flow */

import classNames from 'classnames';
import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './PageContextualLink.style';

import BaseLink from './BaseLink';
import { dimmed } from './setting/pageContextualLinkVariants';
import useEventAccentColor from 'src/shared/domain/event/hook/useEventAccentColor';

type Props = {
  href: string,
  children: React.Node,
  layoutClass?: string,
  isDisabled?: boolean,
  variant?: typeof dimmed,
  handleClick?: () => void,
};

const useStyles = createUseStyles(styles);

const PageContextualLink = ({
  href,
  children,
  layoutClass,
  isDisabled,
  variant,
  handleClick,
}: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const [accentColor] = useEventAccentColor();

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles({ accentColor });

  const rootClasses = classNames(classes.root, layoutClass, {
    [classes['root-isDimmed']]: variant === dimmed,
    [classes['root-isDisabled']]: isDisabled,
  });

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <BaseLink className={rootClasses} href={href} handleClick={handleClick}>
      {children}
    </BaseLink>
  );
};

// Make variants available
export * from './setting/pageContextualLinkVariants';

export default compose(React.memo)(PageContextualLink);
